module.exports = __webpack_public_path__ + "img/case33.76cbc10a.png";